import { GlobalCssPriority } from '@shared/ui';
import { CssBaseline, ThemeProvider } from '@shared/ui/utils';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import theme from '@shared/ui/theme';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import { installFetchWithTelemetry } from './services/fetchWithTelemetry';
import { store } from './store/store';
import './platform/sem/handlers';
import { version } from './generated/version';

// Log version on startup for debugging
console.log(`Moments frontend version: ${version.gitCommit}`);
console.log(`Build time: ${version.buildTime}`);
installFetchWithTelemetry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <GlobalCssPriority>
          <CssBaseline />
          <BrowserRouter>
            <div id="main">
              <App />
            </div>
          </BrowserRouter>
        </GlobalCssPriority>
      </ThemeProvider>
    </Provider>
  </StrictMode>
);
